export enum RestoreTargetEnum {
  EC2,
  Azure
}
